import { gql } from '@apollo/client';

export const deleteFacility = gql`
  mutation deleteFacility($id: String) {
    deleteFacility(id: $id) {
      id
      ContactListId
      Locations {
        id
      }
      address
      facilityName
      facilityUid
      FacilityType {
        id
        name
      }
      AORs {
        id
        name
      }
      Company {
        id
        name
      }
      notes
      phone
      gps
      scadaId
      flocNumber
      timezone
      updater
      deletedAt
      version
    }
  }
`;
